import React from "react";

interface CreditReportIconProps {
  color?: string;
}

export const IconCreditReport: React.FC<CreditReportIconProps> = ({color = "#191919"}) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="43" height="43" rx="9.5" fill="white" />
      <rect x="0.5" y="0.5" width="43" height="43" rx="9.5" stroke="#EBE9E4" />
      <path
        d="M26 14C26.93 14 27.395 14 27.7765 14.1022C28.8117 14.3796 29.6204 15.1883 29.8978 16.2235C30 16.605 30 17.07 30 18V27.2C30 28.8802 30 29.7202 29.673 30.362C29.3854 30.9265 28.9265 31.3854 28.362 31.673C27.7202 32 26.8802 32 25.2 32H18.8C17.1198 32 16.2798 32 15.638 31.673C15.0735 31.3854 14.6146 30.9265 14.327 30.362C14 29.7202 14 28.8802 14 27.2V18C14 17.07 14 16.605 14.1022 16.2235C14.3796 15.1883 15.1883 14.3796 16.2235 14.1022C16.605 14 17.07 14 18 14M19.6 16H24.4C24.9601 16 25.2401 16 25.454 15.891C25.6422 15.7951 25.7951 15.6422 25.891 15.454C26 15.2401 26 14.9601 26 14.4V13.6C26 13.0399 26 12.7599 25.891 12.546C25.7951 12.3578 25.6422 12.2049 25.454 12.109C25.2401 12 24.9601 12 24.4 12H19.6C19.0399 12 18.7599 12 18.546 12.109C18.3578 12.2049 18.2049 12.3578 18.109 12.546C18 12.7599 18 13.0399 18 13.6V14.4C18 14.9601 18 15.2401 18.109 15.454C18.2049 15.6422 18.3578 15.7951 18.546 15.891C18.7599 16 19.0399 16 19.6 16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 21L23.9855 23.9876C23.8712 24.1008 23.8141 24.1574 23.7452 24.1867C23.6844 24.2125 23.6174 24.2232 23.5507 24.2176C23.4753 24.2113 23.4011 24.1756 23.2528 24.1041L20.7472 22.8959C20.5989 22.8244 20.5247 22.7887 20.4493 22.7824C20.3826 22.7768 20.3156 22.7875 20.2548 22.8133C20.1859 22.8426 20.1288 22.8992 20.0145 23.0124L17 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
